var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
var StyledLabel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var FlexRow = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n"], ["\n  align-items: center;\n  display: flex;\n"])));
var SelectOption = function (_a) {
    var innerRef = _a.innerRef, innerProps = _a.innerProps, data = _a.data, selectProps = _a.selectProps, label = _a.label;
    var _b = selectProps.components, OptionIcon = _b.OptionIcon, OptionLabel = _b.OptionLabel, labelKey = selectProps.labelKey;
    return (React.createElement(FlexRow, __assign({ ref: innerRef }, innerProps),
        OptionIcon && React.createElement(OptionIcon, __assign({}, data)),
        React.createElement(StyledLabel, null, OptionLabel ? React.createElement(OptionLabel, __assign({}, data)) : label || data[labelKey])));
};
export default SelectOption;
var templateObject_1, templateObject_2;
